import BaseResource from '@/app-core/lib/data/resource/BaseResource'

export default class RegisterSaveResource extends BaseResource {
  constructor(payload = {}) {
    super(payload)

    this.first_name = payload.Firstname ?? ''
    this.last_name = payload.Lastname ?? ''
    this.email = payload.Email ?? ''
    this.phone = payload.Phone ?? ''
    this.phone_prefix = payload.PhonePrefix ?? ''
    this.phone_validated = payload.PhoneValidated ?? false
    this.email_validated = payload.EmailValidated ?? false
    this.password = payload.Password ?? ''
    this.password_confirm = payload.PasswordConfirm ?? ''
    this.terms_condition = payload.TermsCondition ?? false

    this.newsletter = payload.MarketingConsent ?? false
    this.sms = payload.MarketingConsent ?? false
    this.push = payload.MarketingConsent ?? false
  }

  /* PROPERTIES */

  /* METHODS */
}
